import { render, staticRenderFns } from "./ReClientNeeds.vue?vue&type=template&id=f76d45e6&scoped=true"
import script from "./ReClientNeeds.vue?vue&type=script&lang=js"
export * from "./ReClientNeeds.vue?vue&type=script&lang=js"
import style0 from "./ReClientNeeds.vue?vue&type=style&index=0&id=f76d45e6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f76d45e6",
  null
  
)

export default component.exports